import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-delete-rule',
  templateUrl: './delete-rule.component.html',
  styleUrls: ['./delete-rule.component.scss']
})
export class DeleteRuleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
